<template>
  <div class="contentbox">
    <div class="toptitle">
      <div class="return w">
        <!--<router-link tag="span" to="/commodity">&lt;</router-link>-->
        <!--<span @click="returnrouter">&lt;</span>-->
      </div>
      <div class="w" v-show="$store.state.list_class !== 1">
        <div  @click="switch_sub_route('childorderdetails')" class="title_but" :class="route_name === 'childorderdetails'?'active':''">
          {{$store.state.list_class === 1 ? 'TESCO Order' : 'Case List'}}
        </div>
      </div>
      <div class="w" v-show="$store.state.list_class === 1">
        <div  @click="switch_sub_route('childorderdetails')" class="title_but" :class="route_name === 'childorderdetails'?'active':''">
          Case List
        </div>
      </div>
      <div class="w" v-show="$store.state.list_class !== 1">
        <div  @click="switch_sub_route('delivery')" class="title_but" :class="route_name === 'delivery'?'active':''">
          生產訂單
        </div>
      </div>
      <!--<div class="w" v-show="$store.state.list_class !== 1">-->
        <!--<div @click="switch_sub_route('clinic')" class="title_but" :class="route_name === 'clinic'?'active':''">-->
          <!--CLINIC 管理-->
        <!--</div>-->
      <!--</div>-->
      <div class="w">
        <div @click="switch_sub_route('manage_devices')" class="title_but" :class="route_name === 'manage_devices'?'active':''">
          {{$store.state.list_class === 1 ? 'Equipment List' : '設備管理'}}
        </div>
      </div>
      <div class="w">
        <div @click="switch_sub_route('my_account')" class="title_but" :class="route_name === 'my_account'?'active':''">
          {{$store.state.list_class === 1 ? 'My Account' : '我的賬號'}}
        </div>
      </div>
      <div class="w" v-show="$store.state.list_class !== 1">
        <!--bill_management-->
        <div @click="switch_sub_route('bill_management')" class="title_but" :class="route_name === 'bill_management'?'active':''">
          賬單管理
        </div>
      </div>
      <div class="w" v-show="$store.state.list_class !== 1">
        <div class="title_but" @click="switch_sub_route('customer')" :class="route_name === 'customer'?'active':''">
          客戶管理
        </div>
      </div>
      <div class="w" v-show="$store.state.list_class !== 1">
        <div class="title_but" @click="switch_sub_route('point')" :class="route_name === 'point'?'active':''">
          點數
        </div>
      </div>
      <div class="w" v-show="$store.state.list_class !== 1">
        <div class="title_but">產品認證</div>
      </div>
      <div class="other w">
        <div class="personalicon" @click="showPersonalCenter">
          <img src="../assets/images/personal.png" alt="">
        </div>
      </div>
    </div>
    <!--个人中心-->
    <mt-popup
      v-model="popupVisible"
      :modal="false"
      position="right">
      <slot>
        <div class="PersonalCenter">
          <h1>个人中心</h1>
          <div>公司名称({{$store.state.loginuserdata.enterprise}})</div>
          <div>用户名称({{$store.state.loginuserdata.username}})</div>
          <div>
            <mt-button @click="curtainlogout" type="danger">退出</mt-button>
          </div>
          <div>
            <mt-button @click="showPersonalCenter" type="primary">返回</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <router-view></router-view>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    curtainlogout,
  } from '../assets/js/api'

  export default {
    name: "orderlist",
    data() {
      return {
        popupVisible: false,
        route_name: this.$route.name, //子路由名稱
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {
      this.$store.commit('set_list_class', Number(JSON.parse(localStorage.getItem('userdata')).users_role)) //用户名称

      if (this.$route.query.page_style === 'local'){
        this.route_name = 'local_childorderdetails'
      }
      else if (this.$route.query.page_style === 'management'){
        this.route_name = 'bill_management'
      }
      if (this.$store.state.list_class === 1){
        this.switch_sub_route('childorderdetails')
      }
    },
    methods: {
      switch_sub_route(route_name){
        if ( this.route_name === route_name){
          return
        }
        this.route_name = route_name
        if (route_name === 'bill_management'){
          this.$router.push('/orderlist/delivery?page_style=management')
        }
        else if (route_name === 'clinic'){
          this.$router.push('/orderlist/childorderdetails?page_style=clinic')
        }
        else {
          this.$router.push('/orderlist/'+ route_name)
        }
      },
      showPersonalCenter() {
        this.popupVisible ? this.popupVisible = false : this.popupVisible = true
      },
      curtainlogout() {
        curtainlogout().then(data => {
          sessionStorage.removeItem('LocalShoppingCart');
          sessionStorage.removeItem('order_id');
          sessionStorage.removeItem('quotation_code');
          localStorage.removeItem('logindata');
          localStorage.removeItem('userdata');
          this.$store.commit('res_state')
          this.$router.push({path: '/'});
        })
      },
    },
    destroyed() {//离开该页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll)
    }
    ,
  }
</script>

<style lang="less" scoped>
  @import "../assets/less/base";

  html, body, #app {
    height: 100%;
  }

  body /deep/ .el-date-picker {
    z-index: 2020 !important;
  }

  .contentbox {
    background-color: #f2f2f2;
    width: 100%;
    > .toptitle {
      position: fixed;
      z-index: 1;
      width: 90%;
      justify-content: space-between;
      align-items: center;
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      /*box-shadow: 0 2px 5px 2px #e8e8e8;*/
      text-align: center;
      display: flex;
      padding: 0 5%;
      .w {
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        > i {
          font-size: 30px;
          cursor: pointer;
        }
        .title_but{
          background: #3b8bb0;
          height: 40px;
          line-height: 40px;
          width: 90%;
          cursor: pointer;
          &.active{
            background: #e6a23c;
          }
        }
      }
      .return {
        justify-content: start;
      }
      .other {
        justify-content: flex-end;
        &.show {
          width: 40%;
        }
      }
      img {
        height: 46px;
        cursor: pointer;
      }
      .searchinput {
        position: relative;
        button {
          margin: 0;
          padding: 12px 10px;
        }
        img {
          width: 14px;
          height: 14px;
          margin: 0 10px;
        }
        /deep/ .el-input-group__append {
          border: none;
        }
        .screen_box {
          position: absolute;
          width: 98%;
          background-color: #fff;
          border: 1px solid #DCDFE6;
          top: 54px;
          padding: 0 1%;
          color: #000;
          display: none;
          &.show {
            display: block;
            padding: 0 1% 20px 1%;
            @media (min-width: @screen-xs-max) {
              padding: 0 1% 10px 1%;
            }
          }
          > div {
            border-bottom: 1px solid #DCDFE6;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 5px 10px;
            font-size: 12px;
            label {
              height: auto;
              line-height: initial;
              padding: 4px 0;
              /deep/ span.el-checkbox__label {
                font-size: 12px;
              }
            }
            ul {
              display: flex;
              flex-wrap: wrap;
              li {
                line-height: initial;
                height: auto;
                margin-right: 10px;
                label {
                  /deep/ span {
                    font-size: 12px;
                  }
                }
              }
            }
            .screen_number {
              font-weight: bold;
              height: auto;
              line-height: initial;
              margin-left: 20px;
              cursor: pointer;
            }
            .screen_number_input {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .separator {
                padding: 0 20px;
              }
              .el-input-number {
                width: 30%;
              }
            }
            .el-slider, .el-date-editor--daterange {
              width: 100%;
            }
            .range_date_box {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              > div {
                line-height: initial;
                height: auto;
              }
              .separator {
                padding: 0 10px;
              }
            }
          }
          .titlebox {
            /*box-shadow: 0 0 6px 2px #e8e8e8;*/
            line-height: initial;
            height: auto;
            padding: 10px 0;
            align-items: center;
            font-size: 14px;
          }
          .date {
            border: none;
          }
        }
      }
      .personalicon {
        @media (min-width: @screen-xs-max) {
          display: block !important;
        }
        img {
          height: 32px;
          /*margin-left: 10px;*/
          cursor: pointer;
        }
      }
      .title {
        @media (min-width: @screen-xs-max) {
          display: block !important;
        }
      }
      .return {
        font-size: 40px;
        left: 0.2rem;
        cursor: pointer;
      }
    }
    .PersonalCenter {
      background-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 30%;
      text-align: center;
      h1 {
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div {
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .purchase_order_list_box {
      width: 70%;
      .purchase_order_list {
        padding: 20px;
        margin: 0 auto;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        li {
          width: 20%;
          padding: 50px 20px;
          text-align: center;
          cursor: pointer;
          > img {
            max-width: 100%;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist.vue